// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xg7J","right":"styles_right__1aGac"};